module.exports = __webpack_public_path__ + "img/wap_01.a99950b8.png";